export const InfoBannerData01 = [
  {
    img: "https://via.placeholder.com/720x525",
    title: "Meditation classes",
    content: "Lorem ipsum dolor amet consectetur adipiscing do eiusmod tempor.",
    price: "$100 Per month",
    btnName: "Join classes",
    btnLink: "#",
  },
  {
    img: "https://via.placeholder.com/720x525",
    title: "Sound therapy",
    content: "Lorem ipsum dolor amet consectetur adipiscing do eiusmod tempor.",
    price: "$150 Per month",
    btnName: "Join classes",
    btnLink: "#",
  },
  {
    img: "https://via.placeholder.com/720x525",
    title: "Kundalini yoga",
    content: "Lorem ipsum dolor amet consectetur adipiscing do eiusmod tempor.",
    price: "$180 Per month",
    btnName: "Join classes",
    btnLink: "#",
  },
];

export const InfoBannerData03 = [
  {
    img: "/assets/img/product/without-bg/Special Jaggery Cardamom Tea.png",
    // "https://via.placeholder.com/281x217",

    title: "Special Jaggery Cardamom Tea",
    content: "Sweet jaggery with cardamom, brewed for authentic taste",
    // price: "JUST $19.00",
  },
  {
    img: "/assets/img/product/without-bg/Lemon Tea.png",
    title: "Lemon Tea",
    content: "Refreshing citrus chai with a zesty twist of lemon",
    // price: "JUST $21.00",
  },
  {
    img: "/assets/img/product/without-bg/apple Ice Tea.png",
    title: "Apple Ice Tea",
    content: "Refreshing iced tea infused with crisp apple flavor",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Lemon Ice Tea.png",
    title: "Lemon Ice Tea",
    content: "Refreshing citrus blend, chilled perfection with chai vibes",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Black Tea.png",
    title: "Black Tea",
    content: "Strong, classic brew with bold authentic Indian taste",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Masala Black Tea.png",
    title: "Masala Black Tea",
    content: "Bold, spiced blend delivering authentic Indian Tea flavor",
    // price: "JUST $16.00",
  },
];
export const InfoBannerData06 = [
  {
    img: "/assets/img/product/without-bg/Special Jaggery Cardamom Tea.png",
    // "https://via.placeholder.com/281x217",

    title: "Special Jaggery Cardamom Tea",
    content: "Sweet jaggery with cardamom, brewed for authentic taste",
    // price: "JUST $19.00",
  },
  {
    img: "/assets/img/product/without-bg/Lemon Tea.png",
    title: "Lemon Tea",
    content: "Refreshing citrus chai with a zesty twist of lemon",
    // price: "JUST $21.00",
  },
  {
    img: "/assets/img/product/without-bg/apple Ice Tea.png",
    title: "Apple Ice Tea",
    content: "Refreshing iced tea infused with crisp apple flavor",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Lemon Ice Tea.png",
    title: "Lemon Ice Tea",
    content: "Refreshing citrus blend, chilled perfection with chai vibes",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Black Tea.png",
    title: "Black Tea",
    content: "Strong, classic brew with bold authentic Indian taste",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Masala Black Tea.png",
    title: "Masala Black Tea",
    content: "Bold, spiced blend delivering authentic Indian Tea flavor",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Special Jaggery Coffee.png",
    title: "Special Jaggery Coffee",
    content:
      "Special jaggery coffee brewed with rich, authentic Indian flavors.",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Special Ginger Ice Tea.png",
    title: "Special Ginger Ice Tea",
    content: "Refreshing blend of ginger and chilled premium ice tea",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Slice Cake.png",
    title: "Slice Cake",
    content: "Freshly baked, soft, perfect companion to chai",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Shrewsbury Biscuits.png",
    title: "Shrewsbury Biscuits",
    content: "Fresh, buttery biscuits perfectly paired with hot chai",
    // price: "JUST $16.00",
  },
  {
    img: "/assets/img/product/without-bg/Cupcake.png",
    title: "Cupcake",
    content: "Warm, fluffy, sweet treat paired with kulhad chai",
    // price: "JUST $16.00",
  },
  {
    img: "https://res.cloudinary.com/duk4olh1p/image/upload/v1758808482/Cream_Roll_zqqg5u.png",
    title: "Cream Roll",
    content: "Soft, fresh bakery roll paired perfectly with chai",
    // price: "JUST $16.00",
  },
];

export const InfoBannerData05 = [
  {
    img: "https://via.placeholder.com/525x431",
    packageprice: "From $350",
    days: "08 Days",
    title: "Golden triangle of incredible india",
    reviews: "20 Reviews",
    link: "#",
    rating: 5,
  },
  {
    img: "https://via.placeholder.com/525x431",
    packageprice: "From $250",
    days: "10 Days",
    title: "Maldives super resorts with flights",
    reviews: "18 Reviews",
    link: "#",
    rating: 5,
  },
  {
    img: "https://via.placeholder.com/525x431",
    packageprice: "From $700",
    days: "07 Days",
    title: "Dubai parks & resorts special packages",
    reviews: "05 Reviews",
    link: "#",
    rating: 5,
  },
  {
    img: "https://via.placeholder.com/525x431",
    packageprice: "From $350",
    days: "05 Days",
    title: "Majestic india life and great wildlife",
    reviews: "30 Reviews",
    link: "#",
    rating: 5,
  },
  {
    img: "https://via.placeholder.com/525x431",
    packageprice: "From $250",
    days: "10 Days",
    title: "Maldives super resorts with flights",
    reviews: "18 Reviews",
    link: "#",
    rating: 5,
  },
];
